module.exports = __webpack_public_path__ + "static/history-banner-d6823c4cb497015cb655d2e22fbba012.png";